import { useState } from "react";
import { API, useAuth } from "../../App";
import AdminLayout from "../../components/AdminLayout";
import PushNotificationsCard from "../../components/PushNotificationsCard";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { User, Phone, Mail, Save, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminProfile() {
  const { user, refreshUser } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || "",
    phone: user?.phone || "",
    email: user?.email || "",
  });
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!form.name.trim()) { toast.error("Name is required"); return; }
    setSaving(true);
    try {
      const res = await fetch(`${API}/admin/profile`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("Failed to update");
      toast.success("Profile updated!");
      await refreshUser();
    } catch { toast.error("Failed to update profile"); }
    finally { setSaving(false); }
  };

  return (
    <AdminLayout>
      <div className="max-w-lg animate-fade-in space-y-5" data-testid="admin-profile">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 mb-1">My Profile</h1>
          <p className="text-sm text-gray-500">Update your personal details</p>
        </div>

        <div className="bg-white border border-gray-100 rounded-2xl p-6 space-y-5">
          {/* Avatar */}
          <div className="flex items-center gap-4 pb-4 border-b border-gray-100">
            <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
              <span className="text-2xl font-bold text-green-700">{(user?.name || "U")[0].toUpperCase()}</span>
            </div>
            <div>
              <p className="font-semibold text-gray-900">{user?.name}</p>
              <p className="text-[10px] text-gray-400 capitalize">{user?.role} account</p>
            </div>
          </div>

          <div>
            <Label className="text-[10px] text-gray-400 mb-1 flex items-center gap-1"><User size={12} /> Name</Label>
            <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="profile-name-input" />
          </div>

          <div>
            <Label className="text-[10px] text-gray-400 mb-1 flex items-center gap-1"><Mail size={12} /> Email</Label>
            <Input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="profile-email-input" />
          </div>

          <div>
            <Label className="text-[10px] text-gray-400 mb-1 flex items-center gap-1"><Phone size={12} /> Phone</Label>
            <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+91 XXXXXXXXXX" data-testid="profile-phone-input" />
          </div>

          <Button onClick={handleSave} disabled={saving} className="w-full bg-green-700 hover:bg-green-800 text-white" data-testid="save-profile-btn">
            {saving ? <Loader2 size={16} className="animate-spin mr-2" /> : <Save size={14} className="mr-2" />}
            Save Changes
          </Button>
        </div>

        <PushNotificationsCard />
      </div>
    </AdminLayout>
  );
}
